import React, { useState, useEffect } from "react";
import axios from "axios";
// import Navbar from "../NavBar";
import CustomNavbar from "../CustomPermissions/CustomNavbar";
import { useParams } from "react-router-dom";

import { getApiUrl, API_ENDPOINTS, API_BASE_URL } from "../../config/api";

const LeaderOldRecords = () => {
  const { id } = useParams();
  const [records, setRecords] = useState([]);
  const [leaderName, setLeaderName] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [superUser, setSuperUser] = useState(false);

  useEffect(() => {
    const fetchRecords = async () => {
      try {
        const response = await axios.get(
          getApiUrl(`/LeadersTable/get_old_month_records/${id}/`, false)
        );
        
        if (response.data) {
          setLeaderName(response.data.leader || "");
          const rawRecords = Array.isArray(response.data.records) ? response.data.records : [];
          setRecords(
            rawRecords.filter(
              (record) =>
                record && (record.total_taskinput !== 0 || record.total_points !== 0)
            )
          );
        }
        
        const superUser = localStorage.getItem("is_superuser");
        setSuperUser(superUser === "true");
      } catch (err) {
        console.error("Fetch records error:", err);
        setError(err.message || "Something went wrong.");
      } finally {
        setLoading(false);
      }
    };

    fetchRecords();
  }, [id]);

  const groupByMonth = (records) => {
    if (!Array.isArray(records)) return {};

    const grouped = records.reduce((acc, record) => {
      if (!record) return acc;
      const { year, month_name } = record;
      if (!year || !month_name) return acc;
      
      const key = `${year}-${month_name}`;
      if (!acc[key]) {
        acc[key] = [];
      }
      acc[key].push(record);
      return acc;
    }, {});

    // Sort keys in descending order
    return Object.fromEntries(
      Object.entries(grouped).sort((a, b) => {
        try {
          const [yearA, monthA] = a[0].split("-");
          const [yearB, monthB] = b[0].split("-");
          
          const yA = parseInt(yearA);
          const yB = parseInt(yearB);
          
          if (yB !== yA) return yB - yA;
          
          const dateA = new Date(`${monthA} 1, ${yearA}`);
          const dateB = new Date(`${monthB} 1, ${yearB}`);
          
          if (isNaN(dateA.getTime())) return 1;
          if (isNaN(dateB.getTime())) return -1;
          
          return dateB - dateA;
        } catch (e) {
          return 0;
        }
      })
    );
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="text-xl font-semibold animate-pulse">Loading...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="text-xl text-red-600 font-semibold">Error: {error}</div>
      </div>
    );
  }

  const groupedRecords = groupByMonth(records);

  return (
    <>
      <div style={{ display: "flex" }}>
        {superUser && (
          <>
            <CustomNavbar />
          </>
        )}
        <div className="container mx-auto p-3">
          <h1 className="text-3xl font-bold text-blue-500 mb-3 text-center">
            Records for {leaderName}
          </h1>
          {Object.keys(groupedRecords).length === 0 ? (
            <div className="flex justify-center">
              <p className="text-lg text-blue-500">No records available.</p>
            </div>
          ) : (
            Object.entries(groupedRecords).map(([key, monthRecords]) => (
              <div key={key} className="mb-5">
                <h2 className="text-xl font-semibold mb-2 text-blue-500 border-b pb-2">
                  {key}
                </h2>
                <div className="overflow-hidden border rounded-md shadow-sm">
                  <table className="w-full bg-white">
                    <thead className="bg-gray-200 text-gray-700">
                      <tr className="text-white bg-blue-500">
                        <th className="py-2 px-4 text-left">Task Name</th>
                        <th className="py-2 px-4 text-left">Target Points</th>
                        <th className="py-2 px-4 text-left">Target Value</th>
                        <th className="py-2 px-4 text-left">Achieved Points</th>
                        <th className="py-2 px-4 text-left">Percentage</th>
                        <th className="py-2 px-4 text-left">Values</th>
                      </tr>
                    </thead>
                    <tbody>
                      {monthRecords.map((record, index) => {
                        const targetPoints = parseFloat(record.target_points || 0);
                        const achievedPoints = parseFloat(record.total_points || 0);
                        const percentage = targetPoints > 0
                          ? ((achievedPoints / targetPoints) * 100).toFixed(2)
                          : "0.00";

                        return (
                          <tr
                            key={index}
                            className={`border-b ${index % 2 === 0 ? "bg-gray-50" : "bg-white"
                              }`}
                            style={{ fontSize: "14px" }}
                          >
                            <td className="py-3 px-4">{record.task_name}</td>
                            <td className="py-3 px-4">{targetPoints.toFixed(2)}</td>
                            <td className="py-3 px-4">{record.task_target}</td>
                            <td className="py-3 px-4">{achievedPoints.toFixed(2)}</td>
                            <td className={`py-3 px-4 font-semibold ${parseFloat(percentage) >= 100 ? "text-blue-600" : "text-red-500"
                              }`}>
                              {percentage}%
                            </td>
                            <td className="py-3 px-4">
                              {record.total_taskinput}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </>
  );
};

export default LeaderOldRecords;
